const React = require('react');
const ToastAlert = require('./toastAlert');
const AjaxFunctions = require('../ajaxFunctions');
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import {Comment} from './comment.jsx'
const TextInputModal = require('./textInputModal.jsx').TextInputModal;
import { DiscussionCommentCard } from '../components/discussionCard';
import { DiscussionMentionInput } from './discussionMentionInput.js';

export class CardComments extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         isExpanded: false,
         reportCommentOpened: false,
         reportCommentMessage: '',
         owners:[]
      }
   }
   
   async componentDidMount(){
      let owners = await AjaxFunctions.getIncubatorOwnerIds(this.props.currentPortfolio);
      this.setState({owners})
   }

   openReportModal(commentText){
      this.setState({
         reportCommentOpened:true,
         reportCommentMessage: commentText
      })
     
   }

   allComments(){
      let comments = this.props.comments;
      if(this.props.currentPortfolio){
         comments = comments.filter(c => c.idPortfolio === this.props.currentPortfolio)
      }
      else{
         comments = comments.filter(c => !c.idPortfolio)
      }
      return comments.map((comment) => {
         return(
            <Comment
               showDelete={true}
               user={comment.user}
               text={comment.text}
               minutesSinceCreation={comment.minutesSinceCreation}
               deleteCommentFunction={() => this.props.deleteCommentFunction(comment.idCardComment)}
               openReportModal={() => this.openReportModal(comment.idCardComment)}
               key={comment.idCardComment}
            />
         )
      })
   }

   sendReportMessage(message){
      let url  = `${window.location.pathname}${window.location.search}`
      AjaxFunctions.reportCardComment(message,url).then((res) => {
         ToastAlert.success("Comment report sent successfully.")
      }, (err) => {
         ToastAlert.warning(`Sorry, there was an error reporting the comment. ${err}`)

      })
   }

   checkIncubatorOwners(idToCheck) {
      const { owners } = this.state;
      return owners.find(owner => owner.idUser == idToCheck);
   }

   checkIncubatorSubmitter(idToCheck) {
      return idToCheck == this.props.idSubmitter;
   }

   render() {
      let comments = this.props.comments;
      if(this.props.currentPortfolio){
         comments = comments.filter(c => c.idPortfolio === this.props.currentPortfolio)
      }
      else{
         comments = comments.filter(c => !c.idPortfolio)
      }
      let commentRows = comments.map((comment) => {
         let commentTime = new Date();
         commentTime.setMinutes(new Date().getMinutes() - comment.minutesSinceCreation);
         return(
            <DiscussionCommentCard 
               isSponsor={idUser => this.checkIncubatorOwners(idUser)}
               isOwner={idUser => this.checkIncubatorOwners(idUser)}
               isSubmitter={idUser => this.checkIncubatorSubmitter(idUser)}
               comment={{...comment, creationTime: commentTime, childComments: []}}
               key={comment.idCardComment} 
               eventHandlers={{onDelete:() => this.props.deleteCommentFunction(comment.idCardComment)}} 
               disableCardPreview
            />
         )
      });
      return(
         <div className='card-comments-container'>
            <div>
               COMMENTS: {comments.length} 
            </div>
            <List>
               {commentRows}
            </List>
            <CreateComment
               createCommentFunction={text => this.props.createCommentFunction(text)}
               currentPortfolio={this.props.currentPortfolio}
               allUsers={comments.map(c => c.user)}
            />
            <TextInputModal
               show={this.state.reportCommentOpened}
               contentText={`Report an Offensive Comment: ${this.state.reportCommentMessage}`}
               label='Reason for Reporting'
               confirmText={'Submit'}
               confirmFunction={(message) => this.sendReportMessage(message)}
               closeFunction={() => this.setState({reportCommentOpened: false})}
            />
         </div>
      );
   }
}


class CreateComment extends React.Component{

   constructor(props) {
      super(props);
      this.maxCommentLength = 1000;
      this.state ={
         inputText: ''
      }
   }

   onChange(event){
      this.setState({inputText: event.target.value});
   }

   async onSubmit(){
      try {
         await this.props.createCommentFunction(this.state.inputText);
         this.setState({inputText: ''});
      }
      catch(err){
         ToastAlert.error(err);
      }
   }

   render() {

      return (
         <div className='createComment'>
            <DiscussionMentionInput
               placeholder='New Comment'
               value={this.state.inputText}
               users={this.props.allUsers || []}
               onChange={(event) => this.onChange(event)}
            />
            <Button
               onClick={() => this.onSubmit()}
               color='primary'
               size="medium"
               variant='contained'
               disabled={this.state.inputText.trim() === ''}
            >
               Submit
         </Button>
         </div>
      );
   }
}